import { ResourceScope } from '@app-types/blackroom-app';
import { TableProps } from '@app/shared/ui-kit/organisms/Table/types';
import {
  ResourceIndexView,
  ResourcesIndexViewQueryVariables,
} from '@app/types/blackroom-api';
import { MRT_RowVirtualizer } from 'mantine-react-table';
import { RefObject } from 'react';

export type ResourceColumn = 'index' | 'resource' | 'createdAt' | 'actions';

export const RESOURCE_LIST_COLUMNS: ResourceColumn[] = [
  'index',
  'resource',
  'createdAt',
];
export const RESOURCE_LIST_DEFAULT_COLUMNS: ResourceColumn[] = [
  'index',
  'resource',
  'createdAt',
];

export interface ResourceListProps extends Omit<
  TableProps<ResourceIndexView>,
  'columns'
> {
  columns?: ResourceColumn[];
  scope?: ResourceScope;
  fetchVariables?: ResourcesIndexViewQueryVariables;
  withNavigation?: boolean;
  rowVirtualizerInstanceRef: RefObject<MRT_RowVirtualizer>;
  onDataChange?: (data: ResourceIndexView[]) => void;
}
